<ng-container *ngIf="isLoading; else viewEntries">
  <div fxLayout="row" fxLayoutAlign="center center" style="height:50vh">
    <uni-loader></uni-loader>
  </div>
</ng-container>

<ng-template #viewEntries>
  <ng-container *ngIf="results?.length > 0; else showMessage">
    <ng-container *ngFor="let section of results">
      <div fxLayout="row" class="module-title-wrapper" fxLayoutAlign="start center" fxLayoutGap="20px">
        <mat-divider class="border-top-width-3" style="width: 50%"></mat-divider>
        <h3 class="font-lg font-bold spacing margin-0" style="text-align:center!important">
          {{ section.entry_type ? section.entry_type : 'Entries' }}
        </h3>
        <mat-divider class="border-top-width-3" style="width: 50%"></mat-divider>
      </div>

      <div *ngIf="connectionType === 'project'" class="width-100">
        <uni-project-entry-cards-group
          [host]="host"
          [entries]="section.entries"
          [featured]="section.entries.length === 1"
          [showUsers]="false" align="center">
        </uni-project-entry-cards-group>
      </div>

      <ng-container *ngIf="connectionType === 'publication'">
        <uni-publication-entry-cards-group
          [host]="host"
          [entries]="section.entries"
          [featured]="section.entries.length === 1">
        </uni-publication-entry-cards-group>
      </ng-container>

      <ng-container *ngIf="connectionType === 'blog'">
        <uni-blog-entry-cards-group
          [host]="host"
          [entries]="section.entries"
          [featured]="section.entries.length === 1">
        </uni-blog-entry-cards-group>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #showMessage>
    <div class="text-center height-50vh" fxLayout="row" fxLayoutAlign="center center">
      <p class="font-sm"> Result isn't announced yet, please visit this page later.</p>
    </div>
  </ng-template>

  <ng-container *ngIf="loadMore; else showButton">
    <div fxLayout="row" fxLayoutAlign="center center">
      <uni-loader></uni-loader>
    </div>
  </ng-container>

  <ng-template #showButton>
    <div *ngIf="next"  fxLayout="row" fxLayoutAlign="center center" class="margin-top-6">
      <uni-state-button
        default="Load More"
        button_class="secondary"
        (click)="getEntries()">
      </uni-state-button>
    </div>
  </ng-template>
</ng-template>
